module.exports = __webpack_public_path__ + "img/kematian-header.a73d07db.jpg";